"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupAPI_SERVICE_CONNECTION_ERROR = void 0;

var validator_id_1 = require("../../../validator-id");

var categories_1 = require("../../categories");

function setupAPI_SERVICE_CONNECTION_ERROR(builder) {
  builder.validator(validator_id_1.ValidatorID.API_SERVICE_CONNECTION_ERROR).category(categories_1.ValidatorCategory.ApiServer).title('Failure connecting to Kubernetes API Server').description("\nThis error happens if Kubevious Agent fails to connect to Kubernetes API Services.\n");
}

exports.setupAPI_SERVICE_CONNECTION_ERROR = setupAPI_SERVICE_CONNECTION_ERROR;